module.exports = __webpack_public_path__ + "assets/fad90e3f97d38b6ee93b267adbe74ebf.mp3";